__turbopack_context__.v({
  "header": "quotes-module-module-scss-module___66QwW__header",
  "quoteCitation": "quotes-module-module-scss-module___66QwW__quoteCitation",
  "quoteLink": "quotes-module-module-scss-module___66QwW__quoteLink",
  "quoteText": "quotes-module-module-scss-module___66QwW__quoteText",
  "quotes": "quotes-module-module-scss-module___66QwW__quotes",
  "quotesModule": "quotes-module-module-scss-module___66QwW__quotesModule",
});
